/**
 * 台帳の一覧・台帳の行・評価基準と証跡の画面の新しい文言（ja / en）。i18n.ts が合成する。
 * 台帳名・様式番号・列名・評価基準の本文・生産物・要求事項名は制度用語なので訳さない（ここには入れない）。
 * 見出し・ボタンは「〜する」の能動形。
 */
export const ja: Record<string, string> = {
  // ── 台帳の一覧 ──
  "reg.list.intro": "台帳を開くと、行の確認・追加・修正・廃止、履歴の確認、CSV の取込ができます。",
  "reg.list.empty": "台帳はまだありません",
  "reg.list.emptyBody": "台帳の定義が読み込まれていません。セキュリティ担当に連絡してください。",

  // ── 台帳の行 ──
  "reg.addAction": "行を追加する",
  "reg.saveAction": "保存する",
  "reg.importRun": "取り込む",
  "reg.asOfWhat": "「この日時点」とは？",
  "reg.toast.saved": "保存しました",
  "reg.toast.retired": "廃止しました",
  "reg.toast.imported": "取り込みました",
  "reg.hist.heading": "{key} の履歴",
  "reg.hist.count": "{n} 版（新しい順）",
  "reg.hist.validFrom": "発効日 {date}",
  "reg.hist.empty": "（空）",
  "reg.hist.noChange": "値の変更はありません",
  // 履歴の「誰が」「どの申請で」。{no} は申請番号（開ける人にはリンクになる）
  "reg.hist.by": "記録した人",
  "reg.hist.viaRequest": "申請 {no} で承認",
  "reg.hist.openRequest": "申請の詳細を開く",
  "reg.hist.reqType": "（{type}）",
  "reg.src.MANUAL": "手入力",
  "reg.src.WORKFLOW": "申請の承認",
  "reg.src.IMPORT": "取り込み",
  "reg.src.SYSTEM": "システム",
  "reg.src.INSPECTION": "点検",

  // ── 評価基準と証跡 ──
  "cri.status": "証跡の状態",
  "cri.st.none": "証跡なし",
  "cri.st.empty": "空",
  "cri.st.ok": "あり",
  "cri.deliverableShort": "成果物",
  "cri.pastWrites": "過去の時点を見ています。ここでの保存・紐づけは、今日付けで記録されます。",
  "cri.commentSubmit": "指摘を記録する",
  "cri.err.url": "https:// から始まる URL を入力してください",
  "cri.err.file": "ファイルを選んでください",
};

export const en: Record<string, string> = {
  // ── Register list ──
  "reg.list.intro": "Open a register to view, add, edit and retire rows, read the history, or import a CSV.",
  "reg.list.empty": "No registers yet",
  "reg.list.emptyBody": "The register definitions are not loaded. Contact the security officer.",

  // ── Register rows ──
  "reg.addAction": "Add a row",
  "reg.saveAction": "Save",
  "reg.importRun": "Import",
  "reg.asOfWhat": "What does “as of this date” mean?",
  "reg.toast.saved": "Saved",
  "reg.toast.retired": "Retired",
  "reg.toast.imported": "Imported",
  "reg.hist.heading": "History of {key}",
  "reg.hist.count": "{n} versions (newest first)",
  "reg.hist.validFrom": "Effective {date}",
  "reg.hist.empty": "(empty)",
  "reg.hist.noChange": "No values changed",
  "reg.hist.by": "Recorded by",
  "reg.hist.viaRequest": "Approved via request {no}",
  "reg.hist.openRequest": "Open the request",
  "reg.hist.reqType": " ({type})",
  "reg.src.MANUAL": "Manual entry",
  "reg.src.WORKFLOW": "Request approval",
  "reg.src.IMPORT": "Import",
  "reg.src.SYSTEM": "System",
  "reg.src.INSPECTION": "Inspection",

  // ── Criteria and evidence ──
  "cri.status": "Evidence status",
  "cri.st.none": "No evidence",
  "cri.st.empty": "Empty",
  "cri.st.ok": "Has evidence",
  "cri.deliverableShort": "Output",
  "cri.pastWrites": "You are viewing a past date. Anything you save or link here is recorded as of today.",
  "cri.commentSubmit": "Record the comment",
  "cri.err.url": "Enter a URL that starts with https://",
  "cri.err.file": "Choose a file",
};
